/* scroll to need block header menu */
if($(".js-scroll-link").length > 0) {
  function onScroll(){
    let scroll_top = $(document).scrollTop();
    $('.js-scroll-link').each(function(){
      let hash = $(this).attr("href");
      let target = $(hash);
	  let topHeight = $('.js-header').height() + 100;
      let topDistance = target.position().top - topHeight;
      // if ($(window).width()>768) {
      // if (topDistance <= scroll_top && target.position().top + target.outerHeight() > scroll_top) {
      //     $('.js-scroll-link').removeClass("is-active");
      //     $(this).addClass("is-active");
      //   } else {
      //     $(this).removeClass("is-active");
      //   }
      // }
      if ( $(window).scrollTop() < $('.history-page__main').offset().top && $(window).width() > 768) {
          $('.timesheet__item:first-child() .js-scroll-link').addClass("is-active");
      } else {
          $('.timesheet__item:first-child() .js-scroll-link').removeClass("is-active");
      }
    });
  }

  $(document).on("scroll", onScroll);

  $(".js-scroll-link").on('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    $(document).off("scroll");
    // $('.js-scroll-link').removeClass("is-active");
    // $(this).addClass("is-active");
    let hash = $(this).attr("href");
    let target = $(hash);
    let topHeight = $('.js-header').height();
    if ($(window).width()>768) {
      $("html, body").animate({
          scrollTop: target.offset().top - topHeight - 45
      }, 1000, function(){
        $(document).on("scroll", onScroll);
      });
    } else {
      $("html, body").animate({
          scrollTop: target.offset().top - topHeight - 98
      }, 1000, function(){
        $(document).on("scroll", onScroll);
      });
    }

    return false;
  });
}

  let $historyYear = $('.history-page__aside');
  if ($historyYear.length) {
      let $historyTopPoint = $historyYear.offset().top - 160;

      function fixedHistoryYear(){
          if($(window).scrollTop() >= $historyTopPoint ){
              $historyYear.addClass("fixed");
          }
          else {
              $historyYear.removeClass("fixed");
          }  
      }

      fixedHistoryYear();

      $W.scroll(function() {
        fixedHistoryYear();
      });

    }

    function mobilePoint(){
       let $point1 = $(window).scrollTop();

       $('.timeevents__item').each(function(){
        let $this = $(this);

        let $point2 = $this.offset().top - 220;


        if($point1 > $point2) {
          $('.timeevents__item').removeClass('active');
          let id = $this.attr('id'),
            $link = $(' .js-scroll-link.timesheet__link[href="#' + id + '"]');

          $('.js-scroll-link.timesheet__link').removeClass('is-active');
          $link.addClass('is-active');
          console.log(2)
        }
       })
    }




      mobilePoint();
      $W.scroll(function() {  
        mobilePoint();
      });

    // $(window).resize(function() {
    //     if ($(window).width()<=1768) {
    //       console.log('1')
    //        mobilePoint();
    //     }
    // });
